/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.onload = $(function(){
  $(document).find('.quot-btn').each(function(){
//     console.log('clicked');
    $(this).on('click', function(e){
      console.log('clicked');
//       e.preventDefault();
      $(this).parents().next('.inquiry-popup-container').css({'visibility':'visible', 'opacity':'1'}).fadeIn(300);
      $('#shopify-section-header').css('z-index','-1');
      $('.product-block-list__item--description .card').css('z-index','-1');
      $('.product-block-list__item--trust .card').css('z-index','-1');
      $('.product-list.flickity-enabled').css('z-index','-1');
      $('.product-block-list__item--reviews .card').css('z-index','-2');
      $("body").css("overflow", "hidden");
      var current = $(window).scrollTop();
      $(window).scroll(function() {
        $(window).scrollTop(current);
      });
    });
  });
  $('.close').each(function(){
    $(this).click(function(){
      $(this).parents('.inquiry-popup-container').css({'visibility':'hidden', 'opacity':'0'}).fadeOut(300);
      $('#shopify-section-header').css('z-index','1');
      $('.product-block-list__item--description .card').css('z-index','1');
      $('.product-block-list__item--trust .card').css('z-index','1');
      $('.product-list.flickity-enabled').css('z-index','1');
      $('.product-block-list__item--reviews .card').css('z-index','1');
      $(window).off('scroll');
    });
  });
  var price_compare = $(".price--compare").length;
//   console.log(price_compare);
  if(price_compare>0){
  var selected_unit = $('.selected-unit');
  selected_unit.show();
  $('.product-form__info-content .price--highlight').append(selected_unit);
  $('.block-swatch__item').click(function(){
    setTimeout(function(){
      $('.product-form__info-content .price--highlight').append(selected_unit);
    },10);
  });
  }
  var htmlstring = $('.shipment').html();
  if(typeof htmlstring  != 'undefined') 
  htmlstring = (htmlstring.trim) ? htmlstring.trim() : htmlstring.replace(/^\s+/,'');
  if(htmlstring == '') {
    $('.shipment').hide();
  }
});


// document.addEventListener('click', function(e) {
//   if (e.target && e.target.id === 'popup-btn') {
//     const targetButton = document.querySelector('.show-popup-button-wrapper .cf-btn');
//     console.log(targetButton);
//     if (targetButton) {
//       targetButton.click();
//     }
//   }
// });

// document.addEventListener('click', function(e) {
//   if (e.target && e.target.id === 'popup-btn') {
//     // Get all product titles
//     const titles = Array.from(document.querySelectorAll('.line-item__title')).map(el => el.textContent.trim());

//     // Get total quantity
//     const quantities = Array.from(document.querySelectorAll('.quantity-selector__value[data-current-value]')).map(el => parseInt(el.dataset.currentValue, 10));
//     const totalQty = quantities.reduce((sum, qty) => sum + qty, 0);

//     // Log to check
//     console.log('Product Titles:', titles);
//     console.log('Total Quantity:', totalQty);

//     // Save to HTML (example: inject into hidden inputs or a div)
//     const infoContainer = document.getElementById('cart-info-display');
//     if (infoContainer) {
//       infoContainer.innerHTML = `
//         <p><strong>Items:</strong> ${titles.join(', ')}</p>
//         <p><strong>Total Quantity:</strong> ${totalQty}</p>
//       `;
//     }

//     // Optionally, trigger another button
//     const targetButton = document.querySelector('.show-popup-button-wrapper .cf-btn');
//     if (targetButton) {
//       targetButton.click();
//     }
//   }
// });

function updateCartInfoDisplay() {
  const titleElements = Array.from(document.querySelectorAll('.line-item__title'));
  const quantityElements = Array.from(document.querySelectorAll('.hidden-tablet-and-up .quantity-selector__value[data-current-value]'));
  const vendorElements = Array.from(document.querySelectorAll('.line-item__vendor'));
  const skuElements = Array.from(document.querySelectorAll('.line-item_sku'));

  const titles = titleElements.map(el => el.textContent.trim());
  const quantities = quantityElements.map(el => parseInt(el.dataset.currentValue, 10));
  const vendors = vendorElements.map(el => el.textContent.trim());
  const skus = skuElements.map(el => el.textContent.trim());

  const totalQty = quantities.reduce((sum, qty) => sum + qty, 0);

const productDetails = Array.from(document.querySelectorAll('.line-item')).map(item => {
  const title = item.querySelector('.line-item__title')?.textContent.trim() || '';
  const qty = item.querySelector('.quantity-selector__value[data-current-value]')?.dataset.currentValue || '0';
  const vendor = item.querySelector('.line-item__vendor')?.textContent.trim() || '';
  const price = item.querySelector('.line-item__price')?.textContent.trim() || '';
  const sku = item.querySelector('.line-item_sku')?.textContent.trim() || '';

  return `${sku}    ${vendor}    ${title}    -Price:${price}    -Quantity: ${qty}`;
});

const finalValue = '\n' + productDetails.join('\n');


  const infoContainer = document.getElementById('cart-info-display');
  if (infoContainer) {
    infoContainer.innerHTML = `
<p class="final-pro-names"><strong>Items:</strong><br>${productDetails.join('\n').replace(/\n/g, '<br>')}</p>
      <p class="final-quantity"><strong>Total Quantity:</strong> ${totalQty}</p>
    `;
  }

  if (window.acerillCustomFormsEventBus) {
    window.acerillCustomFormsEventBus.publish({
      eventType: 'UPDATE_VALUE_COMMAND',
      fieldPredicate: { label: 'Menge des Artikeles' },
      value: String(totalQty)
    });

window.acerillCustomFormsEventBus.publish({
  eventType: 'UPDATE_VALUE_COMMAND',
  fieldPredicate: { label: 'Produktname / Produktnamen' },
  value: finalValue
});
  const productNameInput = document.getElementById('c65e3ae9-a4a0-441d-b36f-da0df7c92ca5'); // or querySelector with label if needed
  if (productNameInput) {
    productNameInput.setAttribute('readonly', true);
  }
      const quantityInput = document.getElementById('8164ba1f-ebc2-4f59-9fe0-676534832b9f');
  if (quantityInput) {
    quantityInput.setAttribute('readonly', true);
  }
    console.log('✅ Form updated with product info on new lines.');
  } else {
    console.warn('⚠️ Acerill event bus not available yet.');
  }
}





// Run once on page load
document.addEventListener('DOMContentLoaded', updateCartInfoDisplay);

// Also run on #popup-btn click (your existing delegated handler)
document.addEventListener('click', function(e) {
  if (e.target && e.target.id === 'popup-btn') {
    updateCartInfoDisplay();

    
    const targetButton = document.querySelector('.show-popup-button-wrapper .cf-btn');
    if (targetButton) {
      targetButton.click();
    }
  }
});
